<script>
  import { imgSrc } from '$client';
  export let data = {};
</script>

<section class="container">
  <div>
    <img loading="lazy" src={imgSrc(data.img.data.attributes.url)} alt={data.img.data.attributes.alternativeText} />
    <div>
      <h2>{@html data.header}</h2>
      <p>{@html data.description}</p>
      <a href={data.url} target="_blank" rel="nofollow">
        <img
          loading="lazy"
          height="100%"
          width="100%"
          src="https://admin.uberi.pro/uploads/googleplay_24123898a3.webp"
          alt="Приложение водителей" />
      </a>
    </div>
  </div>
</section>

<style lang="scss">
  section {
    overflow: hidden;

    @media only screen and (max-width: 767.98px) {
      background-color: rgb(34 234 172 / 100%);
    }

    > div {
      display: inline-flex;
      gap: 150px;
      align-items: flex-start;
      justify-content: space-between;
      padding-top: 80px;
      background-color: rgb(34 234 172 / 100%);
      border-radius: 10px;
      padding-inline: 100px;

      @media only screen and (max-width: 991.98px) {
        padding-inline: 50px;
      }

      @media only screen and (max-width: 767.98px) {
        background-color: transparent;
        padding-inline: 0;
      }

      @media only screen and (max-width: 991.98px) {
        gap: 70px;
      }

      @media only screen and (max-width: 510px) {
        position: relative;
        gap: 40px;
        padding-block: 40px;
      }

      h2 {
        font-weight: 800;
        font-size: 45px;
        font-family:
          Vela Sans,
          sans-serif;

        @media only screen and (max-width: 1199.98px) {
          font-size: 35px;
        }

        @media only screen and (max-width: 991.98px) {
          font-size: 30px;
        }

        @media only screen and (max-width: 767.98px) {
          font-size: 25px;
        }
      }

      p {
        z-index: 2;
        font-size: 20px;
        font-family: Roboto, sans-serif;

        @media only screen and (max-width: 1199.98px) {
          font-size: 17px;
        }

        @media only screen and (max-width: 991.98px) {
          font-size: 15px;
        }

        @media only screen and (max-width: 510px) {
          font-size: 13px;
        }
      }

      > img {
        width: 400px;
        border-radius: 10px;

        @media only screen and (max-width: 1199.98px) {
          width: 210px;
        }

        @media only screen and (max-width: 510px) {
          position: absolute;
          right: -120px;
          bottom: 0;
          width: 200px;
        }
      }

      div {
        display: flex;
        flex-direction: column;
        gap: 40px;
        align-items: flex-start;

        @media only screen and (max-width: 510px) {
          justify-content: space-between;
          max-width: 60%;
        }
      }

      a {
        z-index: 2;
        display: block;
        width: 180px;
        height: 52px;
        overflow: hidden;
        border-radius: 10px;

        img {
          width: 100%;
          height: 100%;
        }

        @media only screen and (max-width: 510px) {
          width: 164px;
          background-size: 164px;
        }
      }
    }
  }
</style>
